// SPDX-FileCopyrightText: 2026 Povl Filip Sonne-Frederiksen
//
// SPDX-License-Identifier: GPL-3.0-or-later

/**
 * Which jobs belong to this session: the events' first `hello` lists every
 * job the server remembers, finished ones included, and those are history —
 * a toast or a refresh is for a job that finishes while the page is open.
 * Pure: no React, no DOM.
 */

import { isTerminal, type Job } from '../api/types';

/** The ids of the finished jobs in `jobs` — taken at the first `hello`, the session's history. */
export function finishedJobIds(jobs: readonly Job[]): Set<string> {
  return new Set(jobs.filter((j) => isTerminal(j.status)).map((j) => j.id));
}

/**
 * The jobs of this session: every job but those already finished at the
 * first `hello` (`history`). Before the `hello` (`history` null) nothing
 * finished is shown yet — it may be history.
 */
export function jobsOfSession(jobs: readonly Job[], history: ReadonlySet<string> | null): Job[] {
  if (history === null) return jobs.filter((j) => !isTerminal(j.status));
  return jobs.filter((j) => !history.has(j.id));
}
